import { useState, useEffect } from 'react';
import { useStationFilter } from './store';
import { SearchByMCHS, SearchByAreas } from './search.helper';

import { Space, Input } from 'antd';
import { Button as CustomButton } from "../Buttons/button";

import IcoSearch from '../../images/ico_search.svg';
import References from '../../helpers/Reference';

export const SearchStation = ({stations, onSearchStation, startPos }) => {

    const [isExpand, setIsExpand] = useState( false );
    const [searchStations, setSearchStations] = useState( stations );
    const { term, mchs, areas } = useStationFilter();

    useEffect(() => {
        StationSearch();
    },
    [ term, mchs, areas ]);

    const StationSearch = () => {
        setSearchStations( stations.filter(elem => {
            let condTerm = term.length === 0 || elem.name.indexOf( term ) !== -1;        
            let condFilter = SearchByMCHS( elem, mchs.items, mchs.orAnd );
            let condArea = SearchByAreas( elem, areas );
    
            return condTerm && condFilter && condArea;
        }) );
    }

    const onStationSearchClickExpand = () => {
        setIsExpand( !isExpand );
    }

    const onStationSearchClick = ( e, s ) => {
        setIsExpand( false );
        onSearchStation( s );
    };

    const onStattionSearchKeyPress = ( e ) => {
        useStationFilter.setState({term: e.target.value});
    }

    return (
        <>
        <CustomButton
            id="search_station_btn"
            position={{left: 10, top: startPos}}
            type="circle"
            icon={IcoSearch}
            tooltip={{
                title: References.dictionary.tooltips.button_search_station
            }}
            size="md"
            handleClick={onStationSearchClickExpand}
        />        
            <div id="panel-station-search" className={isExpand ? "panel-station-search-expand" : "panel-station-search-collapse"}>
                <span className="close" onClick={onStationSearchClickExpand}>&times;</span>
                <div className="mt-4 text-left p-1">
                    <Input placeholder="Название поста" onChange={onStattionSearchKeyPress}/>
                </div>
                <div id="station-search-items" className="mt-1">
                    {searchStations.map((s, i) =>
                            <div key={s.uuid} onClick={(e) => onStationSearchClick(e, s)} className="panel-station-search-item">
                                <Space>
                                    <div className="level_code_lamp">
                                        <div level_code_text={s.state.level_code}>&#9679;</div>
                                    </div>
                                    {s.name}
                                </Space>
                            </div>
                    )}
                </div>

            </div>
        </>
    );
}